// @ ACL Module Routes
export default [
    // ** Roles
    {
        path: "/wallet/recharge",
        name: "wallet.recharge",
        component: () => import("@/views/wallets/RechargeWallet.vue"),
        meta: {
            pageTitle: "Wallet",
            breadcrumb: [
                {
                    text: "Recharge",
                    active: true,
                },
            ],
            rule: "editor",
            requiresAuth: true,
        },
    },
    {
        path: "/wallet/transfer",
        name: "wallet.transfer",
        component: () => import("@/views/wallets/WalletTransfer.vue"),
        meta: {
            pageTitle: "Wallet Transfer",
            breadcrumb: [
                {
                    text: "Wallet Transfer",
                    active: true,
                },
            ],
            rule: "editor",
            requiresAuth: true,
        },
    },
    {
        path: "/bkash/payment-status",
        name: "wallet.payment-status",
        component: () => import("@/views/wallets/BkashPaymentStatus.vue"),
        meta: {
            pageTitle: "Wallet",
            breadcrumb: [
                {
                    text: "Verifying Your Payment",
                    active: true,
                },
            ],
            rule: "editor",
            requiresAuth: true,
        },
    },
    {
        path: "/nagad/payment-status",
        name: "wallet.payment-status",
        component: () => import("@/views/wallets/NagadPaymentStatus.vue"),
        meta: {
            pageTitle: "Wallet",
            breadcrumb: [
                {
                    text: "Verifying Your Payment",
                    active: true,
                },
            ],
            rule: "editor",
            requiresAuth: true,
        },
    },
    {
        path: "/sslcommerz/payment-status",
        name: "wallet.payment-status",
        component: () => import("@/views/wallets/SslcommerzPaymentStatus.vue"),
        meta: {
            pageTitle: "Wallet",
            breadcrumb: [
                {
                    text: "Verifying Your Payment",
                    active: true,
                },
            ],
            rule: "editor",
            requiresAuth: true,
        },
    },
];
